import MallGroupApi from '@/api/zfb/mall_group'
import { COU_fristStrToLowerCase } from '@/utils/co_util'

// 获取店群内所有的店铺
async function GetMallListByGroupId(page,size,GroupId) {
  return await MallGroupApi.GetMallListByGroupId(page,size,GroupId)
}

// 修改关联店铺的配置(邀请码/是否可以查看其他店铺的订单)
async function UpdataMallGroupConfig(record, key) {
  var relationId = record.Id
  var val = record[key]
  var modifyType = COU_fristStrToLowerCase(key)
  return await MallGroupApi.UpdataMallGroupConfig(relationId,val,modifyType)
}

export default { GetMallListByGroupId, UpdataMallGroupConfig }